import cx from 'classnames'

import Badge from 'common/components/Badge'
import Button from 'common/components/button'
import { successToast } from 'common/components/toastNotification'
import { copyAndReplaceNewLineEmoji } from 'common/helpers/copyAndReplaceNewLineEmoji'
import { containsRtlChars } from 'common/helpers/string'
import { Copy } from 'common/icons'
import { replaceNewLineEmojiAsElement } from 'common/variantsUtils'

type ResultsTableVariantCellProps = {
  value?: string
  isControlVariant: boolean
}

const ResultsTableVariantCell = ({
  value = '',
  isControlVariant,
}: ResultsTableVariantCellProps) => {
  const hasRtlChars = containsRtlChars(value)

  const handleCopy = (text: string) => {
    copyAndReplaceNewLineEmoji(text)

    successToast('Variant copied successfully', { autoClose: 1000 })
  }

  return (
    <div
      className={cx(
        'flex justify-between items-center w-full whitespace-pre-wrap',
        {
          'text-right': hasRtlChars,
        }
      )}
      dir={hasRtlChars ? 'rtl' : 'ltr'}
    >
      <span>
        <span
          className={cx({
            'mr-2': isControlVariant && !hasRtlChars,
            'ml-2': isControlVariant && hasRtlChars,
            'text-base': hasRtlChars,
          })}
        >
          {replaceNewLineEmojiAsElement(value)}
        </span>
        {isControlVariant && <Badge text="Control" variant="warning" />}
      </span>
      <Button
        variant="icon"
        data-cy="copy-variant"
        data-testid="copy-variant"
        title="Copy variant to clipboard"
        className="p-0"
        onClick={() => {
          handleCopy(value)
        }}
        prefixIcon={
          <Copy size={4} className="text-gold-500 hover:text-gold-500" />
        }
      />
    </div>
  )
}

export default ResultsTableVariantCell
